// import { pdfjs } from 'react-pdf';
import mammoth from 'mammoth';
import JSZip from "jszip";
import { pdfjs } from 'pdfjs-dist';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

// Set the workerSrc to the locally imported pdf.worker.js
GlobalWorkerOptions.workerSrc = pdfWorker;

function calculatePages(wordCount) {
    const wordsPerPage = 300;
    const totalPages = Math.ceil(wordCount / wordsPerPage);
    return totalPages;
}


export const getNumPages = async (file) => {
    const fileType = file.type;
    console.log("File Type is:", fileType);

    if (fileType === "application/pdf") {
        // Return a promise that resolves with the page count for PDFs
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const arrayBuffer = e.target.result;
                try {
                    const doc = await getDocument({ data: arrayBuffer }).promise;
                    const numPages = doc.numPages;
                    console.log("Number of pages:", numPages);
                    resolve(numPages); // Resolve the promise with numPages
                } catch (error) {
                    console.error("Error loading the document:", error);
                    reject(error); // Reject the promise on error
                }
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsArrayBuffer(file);
        });
    } else if (fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        // Word document handling
        try {
            const arrayBuffer = await file.arrayBuffer();
            const result = await mammoth.extractRawText({ arrayBuffer });
            const wordCount = result.value.split(/\s+/).length;
            console.log(result, "word result");
            const numPages = calculatePages(wordCount);
            console.log("Number of pages:", numPages);
            return numPages;
        } catch (error) {
            console.error("Error processing Word document:", error);
            throw error;
        }
    } else if (fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
        // PowerPoint handling
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const arrayBuffer = e.target.result;
                try {
                    const zip = await JSZip.loadAsync(arrayBuffer);
                    const slides = zip.folder("ppt/slides/");
                    let numSlides = 0;
                    slides.forEach((relativePath, file) => {
                        if (file.name.endsWith(".xml")) {
                            numSlides++;
                        }
                    });
                    console.log("Number of slides:", numSlides);
                    resolve(numSlides); // Resolve with number of slides
                } catch (error) {
                    console.error("Error processing PowerPoint document:", error);
                    reject(error); // Reject on error
                }
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsArrayBuffer(file);
        });
    } else if (fileType === "text/html") {
        const A4_PAGE_HEIGHT = 1122;
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
                const htmlContent = e.target.result;

                try {
                    const iframe = document.createElement('iframe');
                    iframe.style.visibility = 'hidden';
                    iframe.style.height = '0';
                    iframe.style.width = '0';
                    document.body.appendChild(iframe);

                    iframe.onload = () => {
                        try {
                            const contentHeight = iframe.contentDocument.body.scrollHeight;
                            const totalPages = Math.ceil(contentHeight / A4_PAGE_HEIGHT);
                            console.log('Estimated pages:', totalPages);

                            document.body.removeChild(iframe);
                            resolve(totalPages); // Resolve with number of pages
                        } catch (err) {
                            document.body.removeChild(iframe);
                            console.error('Error calculating page count:', err);
                            reject(err);
                        }
                    };

                    iframe.contentDocument.open();
                    iframe.contentDocument.write(htmlContent);
                    iframe.contentDocument.close();
                } catch (error) {
                    console.error("Error processing HTML content:", error);
                    reject(error); // Reject on error
                }
            };

            reader.onerror = () => reject(reader.error);
            reader.readAsText(file);
        });
    }
    else {
        return 0; // Return 0 if file type is not supported
    }
};


// export const getNumPages = async (file) => {
//     const fileType = file.type;
//     let numPages = 0;

//     if (fileType === "application/pdf") {
//         const reader = new FileReader();
//         reader.onload = async (e) => {
//             const arrayBuffer = e.target.result;
//             try {
//                 const doc = await getDocument({ data: arrayBuffer }).promise;
//                 numPages = doc.numPages;
//                 console.log("Number of pages:", numPages);

//             } catch (error) {
//                 console.error("Error loading the document:", error);
//             }
//         };
//         reader.readAsArrayBuffer(file);
//     }


//     else if (fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
//         const arrayBuffer = await file.arrayBuffer();
//         try {
//             const result = await mammoth.extractRawText({ arrayBuffer });
//             const wordCount = result.value.split(/\s+/).length;
//             numPages = calculatePages(wordCount);
//         } catch (error) {
//             console.error("Error processing Word document:", error);
//         }
//     } else if (fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
//         const reader = new FileReader();
//         const arrayBuffer = await new Promise((resolve, reject) => {
//             reader.onload = () => resolve(reader.result);
//             reader.onerror = () => reject(reader.error);
//             reader.readAsArrayBuffer(file);
//         });

//         try {
//             const zip = await JSZip.loadAsync(arrayBuffer);
//             const slides = zip.folder("ppt/slides/");
//             let numSlides = 0;
//             slides.forEach((relativePath, file) => {
//                 if (file.name.endsWith(".xml")) {
//                     numSlides++;
//                 }
//             });
//             numPages = numSlides;
//         } catch (error) {
//             console.error("Error processing PowerPoint document:", error);
//         }
//     }
//     console.log("returning num pages", numPages);

//     return numPages;
// };